import { actionTypes } from '../actions/data'

// DEFAULT STATE
export const initData = {
  modelDataByTicker: [],
  models: [],
  waiting: true,
  userCustomModelData: null,
  // submittingToPS: false,
  changedEntries: {},
  selectedApproach: null,
  savingInProgress: false,
  selectedTickers: [],
  selectedNewModelNames: [],
  selectedModels: [],
  approachSaved: false,
  sleeveSaved: false,
  riskSaved: false,
  savedToDB: false,
  breadcrumbs: [],
  swaps: [],
  progressBarValue: 0,
  selectedRiskProfileNumber: null,
  tickers: [],
  families: [],
  riskProfiles: [],
  selectedTickerName: [],
  dataFetched: false,
  chosenModels: [],
  name: '',
  index: null,
  length: null,
  allStatuses: [],
  reviewCompleted: false,
  riskSelected: 'no',
  selectedButton: null,
  reviewHoldings: false,
  AllocationsDecided: false,
  stepOneCompleted: false,
  stepTwoCompleted: false,
  stepThreeCompleted: false,
  stepFourCompleted: false,
  stepFiveCompleted: false,
  stepSixCompleted: false,
}

const initialState = initData
// WRITES
//const data = (state = {}, action) => {
const data = (state = initialState, action) => {
  switch (action.type) {

    case actionTypes.START_FETCHING_DATA: {

      return {
        ...state,
        waiting: true
      }
    }
    case actionTypes.FETCH_FUND_DATA: {
      // console.log('FETCH_FUND_DATA')
      const firstItem = action.value.data.find(item => item.modelFamilyDict)
      const families = firstItem ? Object.keys(firstItem.modelFamilyDict) : []

      const models = action.value.data.map(item => {
        const allocation = item.name.match(/\((.*?)\)/)[1]
        return { ...item, allocation }
      })

      const riskProfiles = Array.from(
        new Set(
          models.map(item => JSON.stringify(item.allocation.split('/').map(Number)))
        )
      ).map(item => JSON.parse(item))

      return Object.assign({}, state, {
        models,
        families,
        riskProfiles,
        dataFetched: true,
        waiting: false
      })
    }

    case actionTypes.SET_SELECTED_APPROACH:
      return Object.assign({}, state, {
        selectedApproach: action.value,

      })

    case actionTypes.UPDATE_FAMILIES:
      return Object.assign({}, state, {
        families: action.value
      })

    case actionTypes.UPDATE_RISK_PROFILES:
      return Object.assign({}, state, {
        riskProfiles: action.value
      })
    // case actionTypes.SET_TICKERS:
    //   return Object.assign({}, state, {
    //     tickers: action.tickers
    //   })
    case actionTypes.USER_CHANGED_DATA:
      return Object.assign({}, state, {
        changedEntries: action.value
      })
    case actionTypes.USER_CUSTOM_MODEL_DATA:
      if (action.value.title === null) {
        return {
          ...state,
          userCustomModelData: null
        }
      } else {
        return {
          ...state,
          userCustomModelData: {
            ...state.userCustomModelData,
            [action.value.title]: action.value.userCustomModelData
          }
        }
      }
    case actionTypes.SET_SELECTED_RISK_PROFILES:
      return Object.assign({}, state, {
        selectedRiskProfileNumber: action.value,
        riskSelected: 'yes',
        stepThreeCompleted: true
      })
    case actionTypes.SAVE_MODEL:
      console.log('**', action.value)
      return {
        ...state,
        name: action.value.name,
        index: action.value.index,
        length: action.value.length,
        statuses: action.value.statuses,

      }
    case actionTypes.UPDATE_ALLOCATIONS_DECIDED:
      return {
        ...state,
        AllocationsDecided: action.value,
        stepFourCompleted: true
      };
    case actionTypes.SET_SAVED_APPROACH:
      return Object.assign({}, state, {
        approachSaved: action.value,
        stepOneCompleted: true
      })
    case actionTypes.SET_SAVED_SLEEVE:
      return Object.assign({}, state, {
        sleeveSaved: action.value,
        stepTwoCompleted: true

      })
    case actionTypes.SET_SELECTED_MODEL_TICKERS:
      return Object.assign({}, state, {
        selectedModels: action.value,
        reviewHoldings: true
      })
    case actionTypes.SET_SELECTED_MODEL_NAMES:
      return Object.assign({}, state, {
        selectedNewModelNames: action.value
      })
    case actionTypes.SAVED_TO_DB:

      return Object.assign({}, state, {
        savedToDB: action.value,
        stepSixCompleted: true
      })
    case actionTypes.UPDATE_MODEL_STATUS:
      return {
        ...state,
        models: state.models.map(model =>
          model.customModelName === action.value.modelName
            ? { ...model, status: action.value.status }
            : model
        )
      }

    case actionTypes.SAVING_IN_PROGRESS:
      //   console.log('saving in progress called', action.value)
      return {
        ...state,
        savingInProgress: action.value
      }
    case actionTypes.REVIEW_COMPLETED:
      return {
        ...state,
        reviewCompleted: true,
        stepFiveCompleted: true
      };
    case actionTypes.RESET_STATE:
      //   console.log('reset state called', action.value)
      if (action.value === 'sleeve') {
        return {
          ...state,
          sleeveSaved: initialState.sleeveSaved,
          riskSaved: initialState.riskSaved,
          selectedModels: initialState.selectedModels,
          savedToDB: initialState.savedToDB,
          stepTwoCompleted: initialState.stepTwoCompleted,
          stepThreeCompleted: initialState.stepThreeCompleted,
          stepFourCompleted: initialState.stepFourCompleted,
          stepFiveCompleted: initialState.stepFiveCompleted,
          stepSixCompleted: initialState.stepSixCompleted
        }
      } else if (action.value === 'approach') {
        return {
          ...state,
          approachSaved: initialState.approachSaved,
          sleeveSaved: initialState.sleeveSaved,
          riskSaved: initialState.riskSaved,
          selectedModels: initialState.selectedModels,
          savedToDB: initialState.savedToDB,
          breadcrumbs: initialState.breadcrumbs,
          stepOneCompleted: initialState.stepOneCompleted,
          stepTwoCompleted: initialState.stepTwoCompleted,
          stepThreeCompleted: initialState.stepThreeCompleted,
          stepFourCompleted: initialState.stepFourCompleted,
          stepFiveCompleted: initialState.stepFiveCompleted,
          stepSixCompleted: initialState.stepSixCompleted
        }
      } else if (action.value === 'riskProfiles') {
        return {
          ...state,
          riskSaved: initialState.riskSaved,
          selectedModels: initialState.selectedModels,
          savedToDB: initialState.savedToDB,
          riskSelected: initialState.riskSelected,
          stepThreeCompleted: initialState.stepThreeCompleted,
          stepFourCompleted: initialState.stepFourCompleted,
          stepFiveCompleted: initialState.stepFiveCompleted,
          stepSixCompleted: initialState.stepSixCompleted
        }
      } else if (action.value === 'allocations') {
        return {
          ...state,
          riskSaved: initialState.riskSaved,
          selectedModels: initialState.selectedModels,
          savedToDB: initialState.savedToDB,
          reviewHoldings: initialState.reviewHoldings,
          stepFourCompleted: initialState.stepFourCompleted,
          stepFiveCompleted: initialState.stepFiveCompleted,
          stepSixCompleted: initialState.stepSixCompleted
        }
      } else if (action.value === 'model') {
        return {
          ...state,
          selectedModels: initialState.selectedModels,
          savedToDB: initialState.savedToDB,
          stepFiveCompleted: initialState.stepFiveCompleted,
          stepSixCompleted: initialState.stepSixCompleted
        }
      } else if (action.value === 'save') {
        return {
          ...state,
          savedToDB: initialState.savedToDB,
          stepSixCompleted: initialState.stepSixCompleted
        }
      } else if (action.value === 'resetBreadcrumbs') {
        return {
          ...state,
          breadcrumbs: initialState.breadcrumbs
        }
      }
    case actionTypes.UPDATE_ALL_STATUSES:
      //  console.log('UPDATE_ALL_STATUSES:', action.value)
      return {
        ...state,
        allStatuses: action.value,
        // stepSixCompleted: true
      }

    default:
      return state
  }
}

export const getModelFamilyOption = state => {
  if (state.data && state.data.families) {
    const families = state.data.families
    if (Array.isArray(families) && families.length > 0) {
      return families
    } else {
      return []
    }
  } else {
    return []
  }
}

// function getAssociatedNames(tickers) {
//   return tickers
// }

export const getSelectedTickerNames = state => {
  if (state.data && state.data.models) {
    if (state.data.models.data && state.data.selectedTickers) {
      const selectedTickerNames = state.data.selectedTickers.map(ticker => {
        const model = state.data.models.data.find(model => model.ticker === ticker)
        return model ? model.name : ''
      })
      return selectedTickerNames
    } else {
      return []
    }
  }
}

// READS
export const getSelectedModelFamilyOption = state => state.data.selectedModelFamilyOption
export const getModelDataByTicker = state => state.data.modelDataByTicker
export const getSelectedRiskProfilesNumber = state => state.data.selectedRiskProfileNumber
export const getModels = state => state.data.modelData
export const getModelData = state => state.data.modelData
export const getUserCustomModelData = state => state.data.userCustomModelData
export const getUserChangedEnteries = state => state.data.changedEntries
// export const getSubmittingToPS = state => state.data.submittingToPS
export const getTickers = state => state.data.tickers
export const getRiskProfiles = state => state.data.riskProfiles
export const getSelectedTickers = state => state.data.selectedTickers
//cleanup
export const getSelectedApproach = state => state.data.selectedApproach
export const getApproachSaved = state => state.data.approachSaved
export const getSelectedSleveOption = state => state.data.selectedModelFamilyOption
export default data
